import Uniforms from "./snowfall_uniforms.glsl";
import Vertex from "./snowfall_vertex.glsl";
import { Uniform, Vector3 } from "three";

export default shader => {
  shader.uniforms.time = new Uniform(0.0);
  shader.vertexShader = Uniforms + shader.vertexShader.replace("#include <morphtarget_vertex>", Vertex);
};
